import { getStoredValue } from "../../../_helpers/storagehelper";
import { DraftMessagesActions } from "../../../_store";

const EventLog = (dispatch, infoMessage, redirectURL, Response, Status) => {
  let PUID = getStoredValue("userID");
  let isSALoginAsPU = getStoredValue("isSALoginAsPU");
  let userName = getStoredValue("userName");

  const dataInput = {
    PublicUserID: PUID,
    UserName: userName || "---",
    InfoMessage: infoMessage || "---",
    Response: Response || "---",
    RedirectURL: redirectURL || "---",
    Status: Status || "---",
    isLoginAsSa: isSALoginAsPU,
  };

  dispatch(DraftMessagesActions.SaveTextFile(dataInput));
};

const CreateEventLogTextFile = (
  dispatch,
  infoMessage,
  redirectURL,
  Response,
  Status
) => {
  let PUID = getStoredValue("userID");
  let isSALoginAsPU = getStoredValue("isSALoginAsPU");
  let userName = getStoredValue("userName");

  const dataInput = {
    PublicUserID: PUID,
    UserName: userName,
    InfoMessage: infoMessage,
    Response: Response || "---",
    RedirectURL: redirectURL,
    Status: Status || "---",
    isLoginAsSa: isSALoginAsPU,
  };

  dispatch(DraftMessagesActions.CreateLogTextFile(dataInput));
};

const CreateEventLogTextFileForInbox = (
  dispatch,
  infoMessage,
  redirectURL,
  Response,
  Status
) => {
  let PUID = getStoredValue("userID");
  let isSALoginAsPU = getStoredValue("isSALoginAsPU");
  let userName = getStoredValue("userName");

  const dataInput = {
    PublicUserID: PUID,
    UserName: userName,
    InfoMessage: infoMessage,
    Response: Response || "---",
    RedirectURL: redirectURL,
    Status: Status || "---",
    isLoginAsSa: isSALoginAsPU,
  };

  dispatch(DraftMessagesActions.CreateEventLogTextFileForInbox(dataInput));
};

export { EventLog, CreateEventLogTextFile, CreateEventLogTextFileForInbox };
